var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-breadcrumbs"},_vm._l((_vm.breadcrumbs),function(breadcrumb,b){return _c('router-link',{key:b,staticClass:"app-breadcrumbs__item",attrs:{"to":breadcrumb.link},domProps:{"innerHTML":_vm._s(breadcrumb.text)}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }